const urls = {
	API_URL: process.env.NEXT_PUBLIC_API_URL,
	API_ARTICLE: process.env.NEXT_PUBLIC_ARTICLE,
	API_ARTICLE_SLUG: process.env.NEXT_PUBLIC_ARTICLE_SLUG,
	API_CONTACT_US: process.env.NEXT_PUBLIC_CONTACT_US,
	API_EVENT: process.env.NEXT_PUBLIC_EVENT,
	API_WEB_USERS: process.env.NEXT_PUBLIC_WEB_USERS,
	API_PWD: process.env.NEXT_PUBLIC_PWD,
	API_PARTNER: process.env.NEXT_PUBLIC_PARTNER,

	WEB_VERSION: process.env.NEXT_PUBLIC_WEB_VERSION,
	WEB_URL: process.env.NEXT_PUBLIC_WEB_URL,

	API_PLATFORM: process.env.NEXT_PUBLIC_API_PLATFORM,
	INSIDER_URL: process.env.NEXT_PUBLIC_URL_INSIDER,
	ENV: process.env.NEXT_PUBLIC_WEB_ENV,

	API_SECRET_KEY: process.env.NEXT_PUBLIC_SECRET_KEY,
	API_SECRET_NUMBER: process.env.NEXT_PUBLIC_SECRET_NUMBER,
	API_SECRET_AES_KEY: process.env.NEXT_PUBLIC_WEB_AES_KEY,
};

export default urls;
